import {
  ODataHeader,
  ODataString,
  ODataBoolean,
  ODataDate,
} from "pbas-vue-components";

import { translate } from "../trans";
import store from "@/store";
import { translate2 } from "../trans2";

const InsuranceCarriersHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new ODataHeader({
    type: new ODataString("InsuranceCarrier/Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("InsuranceCarrier/Translations[]/Id"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("InsuranceCarrier/Translations[]/Name", {
      getString: (item) => translate2(item.InsuranceCarrier, "Name"),
      additionalKeys: [new ODataString("InsuranceCarrier/Name")],
    }),
    sortable: true,
    visible: true,
    searchable: true,
    version: 1,
    orderByKey: "InsuranceCarrier/Name",
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("InsuranceCarrier/Name"),
    sortable: true,
    visible: false,
    searchable: true,
    version: 1,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "InsuranceCarrier Id",
    type: new ODataString("InsuranceCarrier/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "InsuranceCarrierId",
    type: new ODataString("InsuranceCarrierId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.policy_number",
    type: new ODataString("PolicyIdentity/Current/Number"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "Policy Id",
    type: new ODataString("PolicyIdentity/Current/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Policy Id",
    type: new ODataString("PolicyIdentity/HasHistory"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  /*new ODataHeader({
      type: new ODataString("PolicyId"),
      visible: false,
      allowVisibilityChange: false
    }),*/
  new ODataHeader({
    title: "globals.status",
    type: new ODataString("PolicyIdentity/Current/Status/Name", {
      getString: (item) => {
        if (!item) return "";
        const lang = store.getters["common/language"];
        return translate(item.PolicyIdentity.Current.Status, lang.language);
      },
    }),
    sortable: true,
    visible: false,
    searchable: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new ODataHeader({
    type: new ODataString(
      "PolicyIdentity/Current/Status/Translations[]/LanguageCode"
    ),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.status",
    type: new ODataString(
      "PolicyIdentity/Current/Status/Translations[]/DisplayValue",
      {
        getString: (item) => {
          if (!item) return "";
          const lang = store.getters["common/language"];
          return translate(item.PolicyIdentity.Current.Status, lang.language);
        },
      }
    ),
    visible: true,
    searchable: true,
    sortable: true,
    orderByKey: "Status/Name",
    version: 1,
  }),
  new ODataHeader({
    title: "Status Id",
    type: new ODataString("PolicyIdentity/Current/Status/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "StatusId",
    type: new ODataString("PolicyIdentity/Current/StatusId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "components.inmemorydependants.effective_date",
    type: new ODataDate("PolicyIdentity/Current/EffectiveDate"),
    sortable: true,
    visible: true,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.address",
    type: new ODataString("Address/City", {
      getString: (item) => {
        var res = "";
        if (item.Address) {
          if (item.Address.SuiteNumber) res += item.Address.SuiteNumber;
          if (item.Address.StreetNumber) {
            if (res.length > 0) res += " ";
            res += item.Address.StreetNumber.toString();
          }
          if (item.Address.StreetName) {
            if (res.length > 0) res += ", ";
            res += item.Address.StreetName;
          }
          if (res.length > 0) res += ", ";
          res += item.Address.City + ", " + item.Address.Province.Code;
          if (item.Address.PostalCode) res += " " + item.Address.PostalCode;
        }
        return res;
      },
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
    subHeaders: [
      new ODataHeader({
        title: "globals.address_street_number",
        type: new ODataString("Address/StreetNumber"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
      }),
      new ODataHeader({
        title: "globals.address_suite_number",
        type: new ODataString("Address/SuiteNumber"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
      }),
      new ODataHeader({
        title: "globals.address_street_name",
        type: new ODataString("Address/StreetName"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
      }),
      new ODataHeader({
        title: "globals.address_province",
        type: new ODataString("Address/Province/Code"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
      }),
      new ODataHeader({
        title: "globals.address_postal_code",
        type: new ODataString("Address/PostalCode"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
      }),
      new ODataHeader({
        title: "globals.address_city",
        type: new ODataString("Address/City"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
      }),
    ],
  }),
  new ODataHeader({
    title: "globals.telephone",
    type: new ODataString("PhoneNumber"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.fax_number",
    type: new ODataString("Fax"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.contacts.email",
    type: new ODataString("Email"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.contacts",
    type: new ODataString("Contacts[]/Name", {
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
    }),
    sortable: false,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "Contacts Id",
    type: new ODataString("Contacts[]/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Contacts Email",
    type: new ODataString("Contacts[]/Email"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Contacts Status Name",
    type: new ODataString("Contacts[]/Status/Name"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Contacts[]/Status/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Contacts[]/Status/Translations[]/DisplayValue"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Contacts Status Id",
    type: new ODataString("Contacts[]/Status/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Contacts StatusId",
    type: new ODataString("Contacts[]/StatusId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Contacts Principal",
    type: new ODataBoolean("Contacts[]/IsPrincipal"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Contacts InHouse",
    type: new ODataBoolean("Contacts[]/IsInHouse"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
];
export default InsuranceCarriersHeaders;
